var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrnamens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.71 31.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:.8;}.cls-2{fill:#fff;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.76,22.41c.44-.14,1.45-.81.8-2.39-.46-1.11,1.13-3.2,3.79-2.86,1.03.13,4.96.11,9.18,3.7,4.08,3.47,10.68,5.98,13.71-.33,1.74-3.62-1.75-4.46-2.3-4.41-.02,0-.03,0-.05,0-.58,0-2.3.36-1.64,2.42.65,2.01-3.32,5.8-8.91,1.11,0,0-4.88-4.16-8.87-4.71-4.9-.67-7.52,2.41-7.83,4.15-.66,3.69,1.62,3.49,2.12,3.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.52,7.37c0-4.07-2.66-7.37-2.66-7.37,0,0-2.66,3.3-2.66,7.37s2.66,7.37,2.66,7.37c0,0,2.66-3.3,2.66-7.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.19,20.86c4.23-3.59,8.15-3.57,9.18-3.7,2.65-.34,4.24,1.76,3.79,2.86-.65,1.58.36,2.25.8,2.39.5.16,2.79.37,2.12-3.33-.31-1.74-2.93-4.82-7.83-4.15-3.99.55-8.87,4.71-8.87,4.71-5.59,4.69-9.56.89-8.91-1.11.67-2.06-1.06-2.43-1.64-2.42-.02,0-.03,0-.05,0-.55-.05-4.04.79-2.3,4.41,3.03,6.32,9.63,3.8,13.71.33Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 32.86,
    cy: 29.32,
    r: 2.38
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrnamens);
export default __webpack_public_path__ + "static/media/ornamens.684d5f0ff586d6015528e56f546da946.svg";
export { ForwardRef as ReactComponent };